import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Quotation } from "@/v2/types";

export default async function FindOneQuotation(id: string): Promise<Quotation> {
    const res = await apiClientWithRefreshToken({
        url: `/quotations/${id}`,
        method: "GET",
    });

    return res.data;
}
